<template>
  <q-page padding>
    <PageHeader
      title="Gestão de EPI's"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <!-- Filtros -->
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-4 col-xs">
        <div class="q-ml-sm titulo-input texto-titulo-input">Unidade</div>
        <lista-unidades-select
          v-model="unidadeSelecionada.unidade"
          class="input-new-design"
        />
      </div>

      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Status (CA)</div>
        <q-select
          label="Digite o Status do CA"
          class="input input-new-design"
          v-model="status"
          dense
          option-value="value"
          option-label="label"
          :options="[
            { label: 'Todos', value: '' },
            { label: 'Válido', value: 'valido' },
            { label: 'Vencido', value: 'vencido' },
          ]"
          outlined
        />
      </div>

      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Buscar Por (CA)</div>
        <q-input
          label="Digite o CA"
          class="input input-new-design"
          v-model="caBusca"
          dense
          outlined
        />
      </div>
    </div>

    <!-- Ações -->
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-lg container-btns"
    >
      <div>
        <q-btn
          :class="{ botaoListagemCa }"
          icon="list"
          label="Produtos com (CA Vinculado)"
          no-caps
          style="color: #5e70a2"
          outline
          class="btn"
          @click="ativarListagemCa"
        />
      </div>
      <div>
        <q-btn
          :class="{ botaoCriarCa }"
          icon="add"
          label="Criar / Atualizar C.A"
          no-caps
          class="btn"
          outline
          style="color: #58c16d"
          @click="ativarCriarCa"
        />
      </div>
    </div>

    <!-- Modal Vinculo -->
    <q-dialog v-model="modalVinculo" position="right" full-height>
      <q-card style="width: 780px; max-width: 90vw" class="q-pa-md">
        <q-card-section>
          <div class="text-h6">Vincular CA</div>
        </q-card-section>

        <q-card-section>
          <div class="q-mb-md">
            <div class="text-brand-5 text-weight-bold">Selecionar CA</div>
            <q-select
              v-model="caSelecionado"
              outlined
              dense
              use-input
              hide-selected
              fill-input
              input-debounce="300"
              :options="optionsCa"
              @filter="filtrarCaModal"
            >
              <template v-slot:no-option>
                <q-item><q-item-section>Sem resultados</q-item-section></q-item>
              </template>
            </q-select>
          </div>

          <div class="col-md-2 col-sm-6 col-xs-6">
            <div class="q-ml-sm titulo-input">Buscar Por produto</div>
            <q-input
              label="Digite o Produto"
              class="input input-new-design"
              v-model="buscaProduto"
              dense
              outlined
            />
          </div>

          <div class="text-brand-5 text-weight-bold q-mt-md q-mb-sm">
            Produtos com CA
          </div>

          <q-markup-table dense flat bordered class="tabela-modal">
            <thead>
              <tr>
                <th style="width: 40px; text-align: center">
                  <q-checkbox
                    v-model="selecionarTodos"
                    @update:model-value="toggleTodos"
                  />
                </th>
                <th style="width: 60px; text-align: left">ID</th>
                <th style="width: 300px; text-align: left">Nome</th>
                <th style="width: 120px; text-align: left">CA atual</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="produto in produtosModal" :key="produto.id">
                <td style="text-align: center">
                  <q-checkbox
                    v-model="produtosSelecionados"
                    :val="produto.id"
                  />
                </td>
                <td>{{ produto.id }}</td>
                <td>
                  {{
                    produto.pivot?.contract_product_description || produto.name
                  }}
                </td>
                <td>
                  {{ produto.pivot?.ca?.code || produto?.ca?.code || "Sem CA" }}
                </td>
              </tr>
            </tbody>
          </q-markup-table>

          <q-pagination
            class="q-mt-md"
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
            @update:model-value="
              listarProdutosModal(pagination.page, pagination.rowsPerPage)
            "
          />

          <q-btn
            class="q-mt-lg full-width"
            label="Vincular a Produto(s)"
            color="positive"
            icon="check_circle"
            :loading="carregando"
            @click="vincularCaProduto"
          />
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Componentes -->
    <ListaVincularCa
      v-if="botaoListagemCa"
      :ca="model"
      :status="status"
      :ca-busca="caBusca"
      :atualizar-tabela="atualizarTabela"
      @limpar="reset"
      @abrir-modal-vinculo="abrirModalVincular"
    />

    <AtualizarECriarCa
      v-if="botaoCriarCa"
      :botaoTipo="'criar'"
      :status="status"
      :ca-busca="caBusca"
    />
  </q-page>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaVincularCa from "../components/ListaVincularCa.vue";
import AtualizarECriarCa from "../components/AtualizarECriarCa.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { watchDebounced } from "@vueuse/core/index.cjs";
import PageHeader from "../../../components/PageHeader.vue";

const store = useStore();
const $q = useQuasar();

const unidadeSelecionada = ref({ unidade: store.state.org.unidadeData });
const status = ref({ label: "Todos", value: "" });
const caBusca = ref("");
const model = ref(null);
const modalVinculo = ref(false);
const caSelecionado = ref(null);
const buscaProduto = ref("");
const produtosModal = ref([]);
const atualizarTabela = ref(0);
const produtosSelecionados = ref([]);
const selecionarTodos = ref(false);
const carregando = ref(false);
const optionsCa = ref([]);

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 15,
  rowsNumber: 9,
});

const botaoListagemCa = ref(true);
const botaoCriarCa = ref(false);

const reset = () => (model.value = null);

const pagesNumber = computed(() =>
  Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
);

const ativarListagemCa = () => {
  botaoListagemCa.value = true;
  botaoCriarCa.value = false;
};

const ativarCriarCa = () => {
  botaoCriarCa.value = true;
  botaoListagemCa.value = false;
};

const abrirModalVincular = () => {
  modalVinculo.value = true;
  produtosSelecionados.value = [];
  listarProdutosModal();
};

const listarProdutosModal = async (page = 1, rowsPerPage = 9) => {
  carregando.value = true;
  try {
    const response = await store.dispatch("produtos/listarProdutos", {
      contract_id: store.state.org.contract,
      ca_status: "",
      ca_code: "",
      search: buscaProduto.value,
      per_page: rowsPerPage,
      page: page,
    });

    produtosModal.value = response.data.model.products.data;

    pagination.value.rowsPerPage = response.data.model.products.per_page;
    pagination.value.page = response.data.model.products.current_page;
    pagination.value.rowsNumber = response.data.model.products.total;
    carregando.value = false;
  } catch (err) {
    carregando.value = false;
    console.error("Erro ao buscar produtos no modal:", err);
  }
};

const toggleTodos = () => {
  produtosSelecionados.value = selecionarTodos.value
    ? produtosModal.value.map((p) => p.id)
    : [];
};

const vincularCaProduto = async () => {
  if (!caSelecionado.value || produtosSelecionados.value.length === 0) {
    $q.notify({
      message: "Selecione ao menos um produto e um CA",
      color: "negative",
    });
    return;
  }

  try {
    await store.dispatch("produtos/vincularCaEmProdutos", {
      contract_id: store.state.org.contract,
      ca_id: caSelecionado.value.value,
      products: produtosSelecionados.value,
    });
    caSelecionado.value = null;
    produtosSelecionados.value = [];
    atualizarTabela.value += 1;
    modalVinculo.value = false;
    $q.notify({
      message: "CA vinculado com sucesso aos produtos!",
      color: "positive",
    });
  } catch (err) {
    console.error(err);
    $q.notify({ message: "Erro ao vincular CA", color: "negative" });
  }
};

const filtrarCaModal = (val, update) => {
  setTimeout(async () => {
    try {
      const response = await store.dispatch("produtos/listarCas", {
        code: val,
      });
      optionsCa.value = response.data.results.data.map((ca) => ({
        value: ca.id,
        label: `${ca.code}-${ca.status}`,
      }));
      update();
    } catch (err) {
      console.error(err);
    }
  }, 500);
};

watch(
  () => store.state.org.unidadeData,
  () => {
    unidadeSelecionada.value.unidade = store.state.org.unidadeData;
  }
);

watchDebounced(
  () => buscaProduto.value,
  () => {
    listarProdutosModal(pagination.value.page, pagination.value.rowsPerPage);
  },
  { debounce: 800 }
);

watch(
  () => pagination.value.rowsPerPage,
  () => {
    listarProdutosModal(1, pagination.value.rowsPerPage);
  }
);
</script>

<style scoped>
.botaoListagemCa {
  color: white !important;
  background-color: #5e70a2 !important;
}
.botaoCriarCa {
  color: white !important;
  background-color: #58c16d !important;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0;
  }
  .select {
    font-size: 12px;
  }
  .container-inputs {
    margin-top: 8px;
    padding: 0;
  }
  .btn {
    font-size: 12px;
    border-radius: 5px;
  }
  .container-btns {
    margin-top: 20px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.titulo-input {
  color: #213864;
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.titulo-input {
  color: #213864;
}
</style>
